import { icon, text } from "@fortawesome/fontawesome-svg-core";

export default {
  items: [
    {
      title: true,
      name: "Settings",
      class: "",
      wrapper: {
        element: "",
        attributes: {},
      },
    },
    {
      name: "Quick setup",
      icon: "icon-speedometer",
    },

    {
      name: "Bot settings",
      url: "./botsettings",
      icon: "icon-settings",
    },
    {
      name: "Commands",
      url: "./commands",
      icon: "icon-wrench",
    },
    {
      name: "Weblogs",
      url: "./weblogs",
      icon: "icon-list",
    },
    {
      title: true,
      name: "Server Discovery",
      class: "",
      wrapper: {
        element: "",
        attributes: {},
      },
    },
    {
      name: "Publish",
      url: "./server-discovery",
      icon: "icon-globe",
      badge: {
        variant: "primary",
        text: "New",
      },
    },
    {
      title: true,
      name: "Premium",
      class: "premium-title",
      wrapper: {
        element: "",
        attributes: {},
      },
    },
    {
      name: "Personalize",
      url: "./personalize",
      icon: "fas fa-magic",
      class: "premium-title",
      class: "premium-title",
      badge: {
        variant: "primary",
        text: "Premium",
      },
    },
    {
      name: "Levels ",
      url: "./levels",
      icon: "icon-chart",
      class: "premium-title",
      badge: {
        variant: "primary",
        text: "Premium",
      },
    },
    {
      name: "Voice link",
      url: "./voicelink",
      icon: "icon-link",
      class: "premium-title",
      badge: {
        variant: "primary",
        text: "Premium",
      },
    },
    {
      name: "Sticky Messages",
      url: "./sticky-messages",
      icon: "icon-note",
      class: "premium-title",
      badge: {
        variant: "primary",
        text: "Premium",
      },
    },
    {
      name: "Auto Purge",
      url: "./auto-purge",
      icon: "icon-trash",
      class: "premium-title",
      badge: {
        variant: "primary",
        text: "Premium",
      },
    },

    {
      title: true,
      name: "Moderation",
      class: "",
      wrapper: {
        element: "",
        attributes: {},
      },
    },
    {
      name: "Automod",
      url: "./automod",
      icon: "icon-shield",
    },
    {
      name: "Moderation",
      url: "./moderation",
      icon: "fa fa-gavel",
    },
    {
      name: "Logging",
      url: "./logging",
      icon: "icon-notebook",
    },

    {
      title: true,
      name: "Roles",
      class: "",
      wrapper: {
        element: "",
        attributes: {},
      },
    },
    {
      name: "Reaction roles",
      url: "./reactionroles",
      icon: "far fa-kiss-wink-heart",
    },
    {
      name: "Autoroles",
      url: "./autoroles",
      icon: "icon-user-follow",
    },

    {
      title: true,
      name: "Custom Commands",
      class: "",
      wrapper: {
        element: "",
        attributes: {},
      },
    },
    {
      name: "Tags",
      url: "./tags",
      icon: "icon-tag",
    },
    {
      name: "Triggers",
      url: "./triggers",
      icon: "icon-speech",
    },
    {
      name: "Autofeeds",
      url: "./autofeeds",
      icon: "icon-feed",
    },

    {
      title: true,
      name: "Notifications",
      class: "",
      wrapper: {
        element: "",
        attributes: {},
      },
    },
    {
      name: "Game Alert",
      url: "./carl-gaming",
      icon: "fas fa-gamepad",
    },

    {
      name: "Twitch",
      url: "twitch",
      icon: "fab fa-twitch",
    },
    {
      name: "Youtube",
      url: "youtube",
      icon: "fab fa-youtube",
    },
    {
      title: true,
      name: "Utility",
      class: "",
      wrapper: {
        element: "",
        attributes: {},
      },
    },
    {
      name: "Greetings",
      url: "./welcome",
      icon: "icon-login",
    },

    {
      name: "Starboard",
      url: "./starboard",
      icon: "icon-star",
    },

    {
      name: "Embeds",
      url: "./embeds",
      icon: "icon-picture",
    },

    {
      name: "Suggestions",
      url: "./suggestions",
      icon: "icon-bulb",
    },
  ],
};
